import { FC, ReactNode, useMemo, useState } from 'react';

import { ModalPopupContext } from './ModalPopupContext';

export type Props = {
  children: ReactNode;
};

export type ModalPopupContextValue = {
  showModal: (payload: ReactNode) => void;
  hideModal: () => void;
};

export const ModalPopupProvider: FC<Props> = ({ children }) => {
  const [modalComponent, setModalComponent] = useState<ReactNode>(null);

  const modalPopupContextValue = useMemo<ModalPopupContextValue>(
    () => ({
      showModal: (modal: ReactNode) => {
        setModalComponent(modal);
      },
      hideModal: () => {
        setModalComponent(null);
      },
    }),
    [],
  );

  return (
    <ModalPopupContext.Provider value={modalPopupContextValue}>
      {modalComponent}
      {children}
    </ModalPopupContext.Provider>
  );
};
